import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schemaData?: Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = "website",
  ogImage,
  schemaData,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:type", ogType);
    if (canonicalUrl) {
      setMeta("og:url", canonicalUrl);
      const link = document.querySelector("link[rel=canonical]") as HTMLLinkElement;
      if (link) link.href = canonicalUrl;
    }
    if (ogImage) setMeta("og:image", ogImage);
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [title, description, keywords, canonicalUrl, ogType, ogImage]);

  const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
    if (!el) {
      el = document.createElement("meta");
      if (name.startsWith("og:")) el.setAttribute("property", name);
      else el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  if (!schemaData) return null;

  return (
    <>
      {schemaData.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </>
  );
}